/**
 * OTA güncelleme ayarları.
 *
 * NEDEN AYRI DOSYA: `liveUpdateService.ts` bu iki değeri `import.meta.env`den
 * okuyordu. ts-jest `import.meta`yı derleyemiyor, dolayısıyla servis test
 * ortamında hiç yüklenemiyordu. Aynı engel `fcmService`te doğrudan,
 * `whatsappMotoru`da zincir üzerinden vardı; bu üçüncüsü.
 *
 * Okuma buraya taşındı, ifadeler DEĞİŞMEDİ — yedek adres ve `|| '0.0.0'`
 * dahil. Kardeşleri: `lib/clientConfig.ts`, `lib/pushConfig.ts`.
 */

/** Supabase Storage public adresi. Ortam değişkeni yoksa canlı projeye düşer. */
const STORAGE_BASE = `${
  import.meta.env.VITE_SUPABASE_URL || 'https://vsdehvywuxrbqjnnphoa.supabase.co'
}/storage/v1/object/public/app-updates`

/** Sürüm bildirimi dosyası. */
export const MANIFEST_URL = `${STORAGE_BASE}/manifest.json`

/** Vite build sırasında gömülen native sürüm. */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION || '0.0.0'
